import { theme } from 'lib/theme';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withSequence,
  withTiming,
} from 'react-native-reanimated';

export const Highlight: React.FC<{
  style?: StyleProp<ViewStyle>;
  highlight: boolean;
  children: React.ReactElement;
}> = ({ highlight, style, children }) => {
  const opacityRef = useSharedValue(0);

  React.useEffect(() => {
    if (highlight) {
      opacityRef.value = withSequence(
        withTiming(0.5, { duration: 500, easing: Easing.ease }),
        withTiming(0, { duration: 300 }),
      );
    }
  }, [highlight, opacityRef]);

  const animatedStyles = useAnimatedStyle(() => {
    return {
      opacity: opacityRef.value,
    };
  });

  return highlight ? (
    <View>
      <Animated.View
        style={[
          {
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            zIndex: 1,
            backgroundColor: theme.colors.yellow,
            pointerEvents: 'none',
          },
          style,
          animatedStyles,
        ]}
      />
      {children}
    </View>
  ) : (
    children
  );
};
